// @flow

import * as React from "react"
import Icon from "../../icon"
import {toDinero} from "../../../util"
import {toggleSelectedSearchItem} from "../../../actions/shop"
import {connect} from "react-redux"
import ClassNames from "classnames"
import {includes} from "lodash"
import type {SearchItem, Dispatch, State as ReduxState} from "../../../types"

type Props = {
  +item: SearchItem,
  +parentItem: ?SearchItem,
  +selectedSearchItems: $ReadOnlyArray<number>,
  +isSelected: boolean,
  +isDisabled: boolean,
  +dispatch: Dispatch,
}

class ShopAdminSearchItemListItem extends React.Component<Props> {
  static defaultProps = {
    isSelected: false,
    isDisabled: false,
  }

  handleClick: (SearchItem) => void

  constructor(props: Props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(item: SearchItem) {
    const {dispatch, isDisabled} = this.props
    !isDisabled && dispatch(toggleSelectedSearchItem(item.key))
  }

  renderCheckbox() {
    const {item, isSelected, isDisabled} = this.props
    const iconName = isSelected
      ? "icon-checkbox-checked"
      : "icon-checkbox-unchecked"
    return (
      <button
        className="btn btn-icon p-0"
        disabled={isDisabled}
        type="button"
        onClick={() => this.handleClick(item)}
      >
        <Icon name={iconName} />
      </button>
    )
  }

  render() {
    const {item, selectedSearchItems, isDisabled, isSelected, dispatch} =
      this.props
    const isParent = item.items && item.items.length > 0
    const className = ClassNames("shop-admin-search-item-list-item", {
      "is-parent": isParent,
      "is-disabled": isDisabled,
    })
    return (
      <li className={className}>
        {this.renderCheckbox()}
        <span onClick={() => this.handleClick(item)}>
          {item.name}
          <span className="text-gray pl-2">
            <small>{toDinero(item.total).toFormat("$0,0.00")}</small>
          </span>
        </span>

        {isParent && (
          <ul>
            {item.items.map((subItem) => (
              <ShopAdminSearchItemListItem
                key={`${subItem.key}`}
                dispatch={dispatch}
                item={subItem}
                onClick={(item) => this.handleClick(item)}
                isDisabled={isParent && isSelected}
                isSelected={
                  isParent && isSelected
                    ? true
                    : includes(selectedSearchItems, subItem.key)
                }
                selectedSearchItems={selectedSearchItems}
                parentItem={item}
              />
            ))}
          </ul>
        )}
      </li>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  selectedSearchItems: state.shop.selectedSearchItems,
})

export default connect(mapStateToProps)(ShopAdminSearchItemListItem)
